import { render, staticRenderFns } from "./BuscaSelosOutrosRegistros.vue?vue&type=template&id=fe705b0c&scoped=true&"
import script from "./BuscaSelosOutrosRegistros.vue?vue&type=script&lang=js&"
export * from "./BuscaSelosOutrosRegistros.vue?vue&type=script&lang=js&"
import style0 from "./BuscaSelosOutrosRegistros.vue?vue&type=style&index=0&id=fe705b0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe705b0c",
  null
  
)

export default component.exports